window.addEventListener('DOMContentLoaded', (event) => {
  setTimeout(function() {
    var phoneInput = document.querySelector('input[name="phone"]');
    if (!phoneInput) {
      return;
    }
    // +81の場合は、0から始まる10桁の数字に変換
    phoneInput.value = phoneInput.value.replace(/^\+81/, '0');

    // submitボタンをクリックしたときに、+81の場合は、0から始まる10桁の数字に変換
    var submitButton = document.querySelector('button[type="submit"]');
    if (!submitButton) {
      return;
    }
    submitButton.addEventListener('click', function(e) {
      setTimeout(function() {
        phoneInput.value = phoneInput.value.replace(/^\+81/, '0');
      }, 500);
    });

    // forcus outしたときに、+81の場合は、0から始まる10桁の数字に変換
    phoneInput.addEventListener('focusout', function(e) {
      setTimeout(function() {
        phoneInput.value = phoneInput.value.replace(/^\+81/, '0');
      }, 500);
    });
  }, 1200);
});

